<template>
  <div>
    <PageHeader title="รายงานสรุปจำนวนคอร์สแยกตามผู้เรียน"></PageHeader>
    <b-container class="mt-5">
      <div class="section-container">
        <div class="search-section">
          <p>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</p>
          <b-row>
            <b-col cols="3">
              <label><strong>วันที่ลงทะเบียน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formatEnrollDate"
                    placeholder="เลือกวันที่ลงทะเบียน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('course-enroll-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="courseEnrollDate"
                  locale="th"
                  id="course-enroll-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
            <b-col cols="3">
              <label><strong>วิชา</strong></label>
              <b-form-select
                v-model="selectedSubject"
                :options="subjectList"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="isWannasorn">
            <b-col cols="3">
              <label><strong>สถาบัน</strong></label>
              <b-form-select
                v-model="selectedSubCompany"
                :options="subCompanyOptions"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-button
            @click="searchCourseInfo()"
            class="search-btn"
            variant="primary"
          >
            <b-icon icon="search"></b-icon>
            ค้นหาข้อมูล
          </b-button>
        </div>

        <div v-if="isShowTable" class="table-section">
          <div class="table-title">
            <p>
              <strong>รายละเอียดจำนวนคอร์สแยกตามผู้เรียน</strong> ผู้เรียน
              {{ studentCourseSummaryList.length }} คน
            </p>
            <b-button @click="generatePdf()" variant="primary">
              <b-icon icon="chevron-double-down"></b-icon>
              ดาวน์โหลดรายงาน pdf
            </b-button>
          </div>
          <p class="remark-text">
            หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
            และดาวน์โหลดลงบนเครื่องของคุณ
          </p>
          <b-table
            id="student-course-summary-list"
            :fields="fields"
            :items="studentCourseSummaryList"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isDataTableLoading"
            hover
            striped
            show-empty
          >
            <template #empty>
              <p class="text-center">ไม่มีข้อมูล</p>
            </template>
          </b-table>
          <b-row class="mt-3" v-if="studentCourseSummaryList.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ studentCourseSummaryList.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="studentCourseSummaryList.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="studentCourseSummaryList.length"
                  aria-controls="student-course-summary-list"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import api from "@/services/api";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import generateAttendanceReportPdfMixin from "../../../mixins/generate-attendance-report-pdf-mixin";
import studentCourseSummaryReport from "../../../mixins/student-course-summary-report";
import subCompanyFilterMixin from "../../../mixins/sub-company-filter-mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [
    dateMixin,
    generateAttendanceReportPdfMixin,
    studentCourseSummaryReport,
    subCompanyFilterMixin,
  ],
  components: {
    PageHeader,
    DatePicker,
  },
  data() {
    const currentDate = new Date();

    return {
      comId: this.$store.state.Company.companyInfo.id,
      moment: moment,
      courseEnrollDate: {
        start: "",
        end: "",
      },
      selectedSubject: "",
      subjectList: [{ value: "", text: "ทั้งหมด" }],
      isShowTable: false,
      isDataTableLoading: false,
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          label: "รหัสผู้เรียน",
          key: "studentId",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "ชื่อผู้เรียน",
          key: "fullName",
        },
        {
          label: "จำนวนคอร์ส",
          key: "enrollCount",
        },
      ],
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "p",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 10,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 40,
          r: 40,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endLarge: 25,
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },
    };
  },
  computed: {
    ...mapGetters("ReportManagement", ["studentCourseSummaryList"]),
    userInfo() {
      return JSON.parse(localStorage.getItem("user"));
    },
    currentProfile() {
      return this.getCurrentProfile(this.userInfo.profiles);
    },
    formatEnrollDate() {
      return this.getFormattedRange(
        this.courseEnrollDate.start,
        this.courseEnrollDate.end,
        "course-enroll-date",
      );
    },
    instituteName() {
      if (this.comId == 1000001) {
        return "สถาบันกวดวิชาเคมี อ.อุ๊";
      } else if (this.comId == 1000002) {
        return "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์";
      } else if (this.comId == 1000003) {
        return "สถาบันกวดวิชาไบโอบีม";
      }
      return "-";
    },
    selectedSubjectText() {
      const selected = this.subjectList.find(
        (item) => item.value === this.selectedSubject,
      );

      return selected ? selected.text : "ทั้งหมด";
    },
  },
  async mounted() {
    let subjects = [];

    this.setDefaultDates();

    await api.get(`/v1/courses/academic-data`).then(({ data }) => {
      subjects = data.data.subjects.map((item) => {
        return { value: item.st_id, text: item.st_name };
      });
    });

    this.subjectList.push(...subjects);

    if (this.isWannasorn) {
      this.loadSubCompanyDropdown();
    }
  },
  methods: {
    ...mapActions("ReportManagement", ["fetchStudentCourseSummaryList"]),
    async fetch(params) {
      this.isDataTableLoading = true;
      try {
        await this.fetchStudentCourseSummaryList(params);
      } finally {
        this.isDataTableLoading = false;
      }
    },
    async searchCourseInfo() {
      let params = {
        subjectTypeId: this.selectedSubject || null,
        startDate: this.courseEnrollDate.start
          ? moment(this.courseEnrollDate.start).format("YYYY-MM-DD")
          : "",
        endDate: this.courseEnrollDate.end
          ? moment(this.courseEnrollDate.end).format("YYYY-MM-DD")
          : "",
        scId: this.selectedSubCompany || null,
      };

      await this.fetch(params);
      this.isShowTable = true;
    },
    getCurrentProfile(profiles) {
      const requestCompany = this.$route.params.company;
      if (requestCompany) {
        let currentCompany = profiles.find(
          (data) => data.company.url === requestCompany,
        );
        if (currentCompany) return currentCompany;
      } else if (localStorage.getItem("ComId")) {
        const currentComId = localStorage.getItem("ComId");
        let currentCompany = profiles.find(
          (data) => data.company.id == currentComId,
        );
        if (currentCompany) return currentCompany;
      }

      return profiles[0];
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.courseEnrollDate.start = ninetyDaysAgo.format(dateFormat);
      this.courseEnrollDate.end = currentDate.format(dateFormat);
    },
  },
};
</script>

<style scoped lang="scss">
.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
